import React from 'react';
import { Divider } from '@mantine/core';
import PuckInlineRichText from '../../proposal/ProposalRichText/PuckInlineRichText';
import { DEFAULT_BORDER_COLOR } from '../../../../shared/boxes/borderStyles';

/**
 * Bloc Puck — Séparateur : un trait, avec un texte optionnel au centre.
 * Le style de trait passe par la prop `variant` de Mantine — un
 * `style={{ borderStyle }}` inline était écrasé par la bordure du composant.
 */
const SectionDivider = ({
  id,
  label = '',
  color = '',
  lineStyle = 'solid',
  labelPosition = 'center',
  /** Espace au-dessus et en dessous — longueur CSS (champ px↔rem). */
  spacing = '1rem',
  puck,
}) => {
  const isEditing = !!puck?.isEditing;
  return (
    <Divider
      label={(isEditing || label) ? (
        <PuckInlineRichText
          id={id}
          puck={puck}
          html={label}
          contentProp="label"
          minHeight={isEditing ? 20 : undefined}
          placeholder="Texte au centre"
          reducedToolbar
        />
      ) : undefined}
      labelPosition={labelPosition}
      color={color || DEFAULT_BORDER_COLOR}
      variant={lineStyle}
      my={spacing || 0}
    />
  );
};

export default SectionDivider;
